<template>
  <div>
    <img src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_200x51.png">
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
  img {
    width: 100px;
  }
</style>
